<script setup lang="ts">
import { NInput } from 'naive-ui'
import { useAttrs } from 'vue'

const props = defineProps({
  value: {
    type: [String, null],
    required: true,
  },
  type: {
    type: String,
    required: false,
    default: 'text',
  },
})

const emit = defineEmits(['update:value', 'input', 'change', 'blur', 'clear', 'focus'])

const attrs = useAttrs()

const onUpdate = (v: any) => {
  emit('update:value', v)
}

const onInput = (v: any) => {
  emit('input', v)
}

const onChange = (v: any) => {
  emit('change', v)
}

const onBlur = (e: any) => {
  if (e?.target?.value) {
    const val = e.target.value
    emit('update:value', String(val).trim())
  }
  emit('blur', e)
}

const onClear = (e: any) => {
  emit('clear', e)
}

const onFocus = (e: any) => {
  emit('focus', e)
}
</script>

<template>
  <!--  <div class="app-input w-full" :class="[(attrs as any).disabled ? 'app-input&#45;&#45;disabled' : '']"> -->
  <NInput
    :value="value"
    v-bind="attrs"
    :type="type as 'text' | 'textarea' | 'password'"
    class="custom-input"
    @update:value="onUpdate"
    @input="onInput"
    @change="onChange"
    @blur="onBlur"
    @clear="onClear"
    @focus="onFocus"
  >
    <template #prefix>
      <slot name="prefix" />
    </template>
    <template #suffix>
      <slot name="suffix" />
    </template>
  </NInput>
<!--  </div> -->
</template>

<style scoped>
/*.app-input--disabled :deep(.n-input) {
  opacity: 1 !important;
}

.app-input--disabled :deep(.n-input__input-el) {
  opacity: 1 !important;
  font-weight: 500;
  color: #111827 !important;
}

.app-input--disabled :deep(.n-input__textarea-el) {
  opacity: 1 !important;
  font-weight: 500;
  color: #111827 !important;
}

.app-input--disabled :deep(.n-input__placeholder) {
  opacity: 1 !important;
  color: #6B7280 !important;
}*/
</style>
